// Canonical machine-type vocabulary for the Chentronix views: process order, labels, colours.
//
// Order follows the FOUNDRY PROCESS rather than the alphabet — sand core → mould → pour → lathe →
// mill — so a floor view reads upstream-to-downstream and a starved machine sits visibly below
// whatever failed to feed it. PRESS and SWISS_LATHE trail because they belong to the `default` and
// `med-factory` fleets, not the foundry line.
//
// POUR is listed before any POUR machine exists (archetype queued, pending a FOCAS port from the
// registry). Naming a type early is deliberate and cheap; the alternative is what already shipped —
// an unlisted type was silently DROPPED from the Dashboard, which is how SAND_CORE and SAND_MOLD,
// the two operations that feed the entire line, went missing from the landing page.
export const TYPE_ORDER = ['SAND_CORE', 'SAND_MOLD', 'POUR', 'LATHE', 'MILL', 'PRESS', 'SWISS_LATHE'];

export const TYPE_LABEL = {
  SAND_CORE: 'Sand Core',
  SAND_MOLD: 'Sand Mold',
  POUR: 'Pour',
  LATHE: 'Lathe',
  MILL: 'Mill',
  PRESS: 'Press',
  SWISS_LATHE: 'Swiss Lathe',
};

// Sand/pour hexes match ControlCenterPage + CapacitySandboxPage on purpose: one machine keeps one
// colour wherever it appears, so a glance across Plan and Live Floor doesn't need re-learning.
export const TYPE_COLOR = {
  SAND_CORE: '#C9A24B',
  SAND_MOLD: '#B5623C',
  POUR: '#A6472E',
  LATHE: 'var(--cn-lathe)',
  MILL: 'var(--cn-mill)',
  PRESS: 'var(--cn-press)',
  SWISS_LATHE: 'var(--cn-gold)',
};

/** `SAND_CORE` → `Sand Core`. An unknown type is title-cased, never blanked. */
export function typeLabel(type) {
  const t = String(type || '').toUpperCase();
  if (TYPE_LABEL[t]) return TYPE_LABEL[t];
  if (!t) return 'Unclassified';
  return t
    .split(/[_\s-]+/)
    .filter(Boolean)
    .map((w) => w.charAt(0) + w.slice(1).toLowerCase())
    .join(' ');
}

export function typeColor(type) {
  return TYPE_COLOR[String(type || '').toUpperCase()] || 'var(--cn-muted)';
}

/**
 * Sort key for a machine type. An unrecognised type sorts LAST but is never filtered out —
 * grouping must degrade to "shown at the bottom", never to "absent".
 */
export function typeIndex(type) {
  const i = TYPE_ORDER.indexOf(String(type || '').toUpperCase());
  return i < 0 ? TYPE_ORDER.length : i;
}
